import { render } from "./VueMentionUpdate.vue?vue&type=template&id=664c758e&scoped=true"
import script from "./VueMentionUpdate.vue?vue&type=script&lang=js"
export * from "./VueMentionUpdate.vue?vue&type=script&lang=js"

import "./VueMentionUpdate.vue?vue&type=style&index=0&id=664c758e&lang=css"
import "./VueMentionUpdate.vue?vue&type=style&index=1&id=664c758e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c758e"]])

export default __exports__